import React from 'react';
import ModernTemplate from './ModernTemplate';
import MagicalTemplate from './MagicalTemplate';
import ModernAgencyTemplate from './ModernAgencyTemplate';
import EditorialMagazineTemplate from './EditorialMagazineTemplate';
import ExpeditionAdventureTemplate from './ExpeditionAdventureTemplate';
import ExecutiveBriefTemplate from './ExecutiveBriefTemplate';
import StudioActionTemplate from './StudioActionTemplate';
import LuxuryRiverTemplate from './LuxuryRiverTemplate';
import TropicalEscapeTemplate from './TropicalEscapeTemplate';
import BoardingPassTemplate from './BoardingPassTemplate';
import DestinationWeddingTemplate from './DestinationWeddingTemplate';

const QuoteRenderer = ({ quoteData, templateId = 'modern', onPayment, isAgentPreview = false }) => {
  if (!quoteData) {
    return (
      <div className="p-8 text-center text-gray-500">
        <p>No quote data available</p>
      </div>
    );
  }

  switch (templateId) {
    case 'modern':
      return <ModernTemplate quote={quoteData} onPayment={onPayment} isAgentPreview={isAgentPreview} />;
    
    case 'magical':
      return <MagicalTemplate quote={quoteData} onPayment={onPayment} isAgentPreview={isAgentPreview} />;
    
    case 'modern_agency':
      return <ModernAgencyTemplate quote={quoteData} onPayment={onPayment} isAgentPreview={isAgentPreview} />;
    
    case 'editorial_magazine':
      return <EditorialMagazineTemplate quote={quoteData} onPayment={onPayment} isAgentPreview={isAgentPreview} />;
    
    case 'expedition_adventure':
      return <ExpeditionAdventureTemplate quote={quoteData} onPayment={onPayment} isAgentPreview={isAgentPreview} />;
    
    case 'executive_brief':
      return <ExecutiveBriefTemplate quote={quoteData} onPayment={onPayment} isAgentPreview={isAgentPreview} />;
    
    case 'studio_action':
      return <StudioActionTemplate quote={quoteData} onPayment={onPayment} isAgentPreview={isAgentPreview} />;
    
    case 'luxury_river':
      return <LuxuryRiverTemplate quote={quoteData} onPayment={onPayment} isAgentPreview={isAgentPreview} />;
    
    case 'tropical_escape':
      return <TropicalEscapeTemplate quote={quoteData} onPayment={onPayment} isAgentPreview={isAgentPreview} />;
    
    case 'boarding_pass':
      return <BoardingPassTemplate quote={quoteData} onPayment={onPayment} isAgentPreview={isAgentPreview} />;
    
    case 'destination_wedding':
      return <DestinationWeddingTemplate quote={quoteData} onPayment={onPayment} isAgentPreview={isAgentPreview} />;
    
    default:
      // Fallback to modern template
      console.warn(`Unknown template ID: ${templateId}. Falling back to 'modern' template.`);
      return <ModernTemplate quote={quoteData} onPayment={onPayment} isAgentPreview={isAgentPreview} />;
  }
};

export default QuoteRenderer;
